import React, { memo } from 'react'
import { useCalculateButtonStyles } from 'src/editor/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/editor/shared/hooks/use-theme-color/use-selected-button-color'
import { Button as CommonButton } from 'src/shared/components/button/button'
import { CommonButtonEntityInterface } from 'src/shared/schemas/buttons/common-button-entity.schema'

interface BaseEditorButtonProps {
  entity: Omit<CommonButtonEntityInterface, 'type' | 'parentId'>
}

// TODO: reuse it in other button components
export const BaseEditorButton = memo(({ entity }: BaseEditorButtonProps) => {
  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })

  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(entity.buttonType)

  return (
    <CommonButton
      iconClassNameBefore={entity.iconClassNameBefore}
      iconClassNameAfter={entity.iconClassNameAfter}
      text={entity.text}
      border={calculatedBorder.desktop}
      mobileBorder={calculatedBorder.mobile}
      subText={entity.subText}
      padding={calculatedPadding.desktop}
      mobilePadding={calculatedPadding.mobile}
      alignSelf={entity.alignSelf}
      mobileAlignSelf={entity.mobileAlignSelf}
      background={
        (entity.background ?? entity.backgroundColor) || buttonBackgroundColor
      }
      mobileBackground={
        (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
        buttonBackgroundColor
      }
      attrId={entity.htmlAttrId}
      width={entity.width}
      mobileWidth={entity.mobileWidth}
      textColor={entity.textColor || buttonTextColor}
      mobileTextColor={entity.mobileTextColor || buttonTextColor}
      mobileSubTextColor={entity.mobileSubTextColor}
      subTextColor={entity.subTextColor}
      textFontSize={calculatedFontSize.desktop}
      mobileTextFontSize={calculatedFontSize.mobile}
      subTextFontSize={entity.subTextFontSize}
      mobileSubTextFontSize={entity.mobileSubTextFontSize}
      textFontFamily={calculatedFontFamily.desktop}
      textFontWeight={calculatedFontWeight.desktop}
      textFontStyle={calculatedFontStyle.desktop}
      lineHeight={calculatedLineHeight.desktop}
      subTextFontFamily={entity.subTextFontFamily}
      subTextFontWeight={entity.subTextFontWeight}
      subTextFontStyle={entity.subTextFontStyle}
      mobileTextFontFamily={calculatedFontFamily.mobile}
      mobileTextFontWeight={calculatedFontWeight.mobile}
      mobileTextFontStyle={calculatedFontStyle.mobile}
      mobileLineHeight={calculatedLineHeight.mobile}
      mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
      mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
      mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
      boxShadow={entity.boxShadow}
      mobileBoxShadow={entity.mobileBoxShadow}
      hover={{
        ...entity.hover,
        backgroundColor:
          entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
      }}
      mobileHover={{
        ...entity.mobileHover,
        backgroundColor:
          entity?.mobileHover?.backgroundColor ||
          entity?.hover?.backgroundColor ||
          hoveredButtonBackgroundColor,
      }}
    />
  )
})
